import {Component, NgZone, OnInit} from "@angular/core";;
import {ActivatedRoute, Router} from "@angular/router";
import {LoadingWheelService} from "../../../root/loading/loading-wheel.service";
import {ModalService} from "../../../root/modal/modal.service";
import {NotificationService} from "../../../root/toast/notification.service";
import {CarTemplateService} from "../car-template.service";
import {CarTemplateFilter} from "../model/car-template-filter";
import {CarTemplate} from "../model/car-template";
import {Observable} from "rxjs/Observable";
import {SessionService} from "../../../core/session.service";
import {Page} from "../../../shared/pager/page";
import {COMPANY_URL, CAR_TEMPLATE_URL, NEW_CAR_TEMPLATE_URL, APPROVAL_STATUS} from "../constants/car-template-constants";
import {PERM_CAR_TEMPLATE_CREATE, PERM_CAR_TEMPLATE_EDIT, PERM_CAR_TEMPLATE_DELETE} from "../permissions/car-template-permissions";

@Component({
    selector: 'car-template-list',
    templateUrl: './car-template-list.component.html',
    providers: [CarTemplateService]
})
export class CarTemplateListComponent implements OnInit {

    REMOVE_ALERT_TITLE = "REMOVE_ALERT_TITLE";
    REMOVE_ALERT_DESCRIPTION = "REMOVE_ALERT_DESCRIPTION";
    CAR_TEMPLATE_TITLE = 'carTemplate.TITLE';

    brands:any[];
    models:any[];
    approvalStatus:any[];
    page:Page = new Page(10,1,0, []);
    carTemplateFilter: CarTemplateFilter = new CarTemplateFilter();

    errorMessages = {
        'ERROR_DELETE': 'carTemplate.error.ERROR_DELETE',
    };

    confirmationMessages = {
        'SUCCESS_DELETE': 'common.confirmationMessage.SUCCESS_DELETE',
    };

    constructor(private modalService:ModalService,
                private loading:LoadingWheelService,
                private route: Router,
                private activatedRoute: ActivatedRoute,
                private session:SessionService,
                private carTemplateService: CarTemplateService,
                private notificationService:NotificationService,
                private  zone: NgZone) {
    }

    ngOnInit() {

            this.carTemplateFilter.approvalStatus = APPROVAL_STATUS.PENDING;
            this.activatedRoute.params.subscribe(params => {
                this.carTemplateFilter.companyId = params['companyId'];

                if (!!(params['status'])) {
                  this.carTemplateFilter.approvalStatus = params['status'];
                }

                this.loadRequiredCollections();
                this.getCarTemplates();
            });
    }

    add(){
        this.route.navigateByUrl(COMPANY_URL + this.carTemplateFilter.companyId + CAR_TEMPLATE_URL + NEW_CAR_TEMPLATE_URL);
    }

    edit(id:string){
        this.route.navigateByUrl(COMPANY_URL + this.carTemplateFilter.companyId + CAR_TEMPLATE_URL + id);
    }

    remove(id:number) {
        this.modalService.show(this.REMOVE_ALERT_TITLE, this.REMOVE_ALERT_DESCRIPTION, () => {
            this.carTemplateService.remove(this.carTemplateFilter.companyId, id).subscribe(() => {
                  this.removeCallback()
            },
            (error) => {
                   this.handleError(error,'ERROR_DELETE');
            });
        });
    }

    isEditable(carTemplate:CarTemplate){
        return this.session.loggedUserAllowed(PERM_CAR_TEMPLATE_EDIT) && carTemplate.oid!=0 && (carTemplate.approvalStatus === APPROVAL_STATUS.PENDING || this.isPictureEditable(carTemplate));
    };

    isRemovable(carTemplate:CarTemplate){
       return this.session.loggedUserAllowed(PERM_CAR_TEMPLATE_DELETE) && carTemplate.oid!=0 && carTemplate.approvalStatus === APPROVAL_STATUS.PENDING;
    };

    canCreate(){
        return this.session.loggedUserAllowed(PERM_CAR_TEMPLATE_CREATE);
    };

    onBrandChange() {
        if (!!this.carTemplateFilter.brand) {
            this.zone.run(() => {
                 this.carTemplateService.getAllModelsByBrand(this.carTemplateFilter.companyId, this.carTemplateFilter.brand).subscribe(carModels => {
                           this.models = carModels;
                 });
             });
        }
        this.page.currentPage = 1;
        this.getCarTemplates();
    }

   onChangePage(event){
       this.page = event.page;
       this.getCarTemplates();
   }

   getCarTemplates() {
       this.loading.show();
       this.zone.run(() => {
           this.carTemplateService.getAllByCompany(this.carTemplateFilter,this.page.currentPage, this.page.itemsPerPage).subscribe(result => {
                this.loadResultOnPage(result);
                this.loading.hide();
           })
        });
   }

   isLoading(){
      return this.loading.isLoading();
   }

   private loadRequiredCollections() {
      this.zone.run(() => {
            this.carTemplateService.getAllBrands(this.carTemplateFilter.companyId).subscribe(carBrands => {
                 this.brands = carBrands;
            });
            this.carTemplateService.getAllApprovalStatus().subscribe(carApprovalStatus => {
                 this.approvalStatus = carApprovalStatus;
            });
       });
   }

   private removeCallback(){
        this.notificationService.displayToast(this.CAR_TEMPLATE_TITLE,this.confirmationMessages['SUCCESS_DELETE'], null, 'SUCCESS');
        this.ngOnInit();
   }

   private handleError(error, errorMessageCode:string) {
        if(error.status == 400){
            let errorObject = JSON.parse(error._body);
            this.notificationService.notifyErrorByCode(errorObject.message);
        } else {
            this.notificationService.notifyErrorByCode(this.errorMessages[errorMessageCode]);
        }
   }

   private loadResultOnPage(result){
         this.page.currentPage = result.currentPage;
         this.page.numPages = Math.ceil(result.totalItems/result.itemsPerPage);
         this.page.pageItems = result.items;
   }

   private isPictureEditable(carTemplate:CarTemplate) {
        return carTemplate.approvalStatus == APPROVAL_STATUS.PENDING_IMAGE_VALIDATION || carTemplate.approvalStatus == APPROVAL_STATUS.PENDING_IMAGE_UPDATE ;
   }

   private showAuxPicture(carTemplate:CarTemplate) {
        return carTemplate.approvalStatus == APPROVAL_STATUS.PENDING_IMAGE_VALIDATION;
   }

   private showInvalidPictureMessage(carTemplate:CarTemplate) {
       return carTemplate.approvalStatus == APPROVAL_STATUS.PENDING_IMAGE_UPDATE;
   }
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/carTemplate/list/car-template-list.component.ts